import { render } from "./scheme_setting_index.vue?vue&type=template&id=64e28031"
import script from "./scheme_setting_index.vue?vue&type=script&lang=js"
export * from "./scheme_setting_index.vue?vue&type=script&lang=js"

import "./scheme_setting_index.vue?vue&type=style&index=0&id=64e28031&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__